<script setup lang="ts">
import type { TableFilterCondition } from "../../../types/TableFilter.types";
import { computed, useId } from "vue";
import { useI18n } from "vue-i18n";
import VModernSelect from "../../AutoComplete/VModernSelect.vue";

const { labelId = undefined, options } = defineProps<{
  options: Array<{ value: TableFilterCondition, name: string }>
  /** Id of the filter's label; the select is named after it, as "<label> condition". */
  labelId?: string
}>();

const condition = defineModel<TableFilterCondition>({ required: true });

const { t } = useI18n();
const conditionLabelId = `${useId()}-condition`;
const ariaLabelledby = computed(() => (labelId ? `${labelId} ${conditionLabelId}` : conditionLabelId));
</script>

<template>
  <span :id="conditionLabelId" class="sr-only">{{ t("filters.condition") }}</span>
  <VModernSelect
    v-model="condition"
    :aria-labelledby="ariaLabelledby"
    :items="options"
    key-field-name="value"
    search-field-name="name"
    :placeholder="t('filters.select_condition')"
  />
</template>
